export interface ServiceInfo {
  enableBusiness: string[];
  recentAccessBusiness: string[];
}
export function defCurrentData() {
  return {
    data: { isOrgOwner: false, isOrgAdmin: false, timeZone: 0, codes: [] as string[] },
  };
}
export interface PermissionCodes {
  isOrgOwner: boolean;
  isOrgAdmin: boolean;
  timeZone: number;
  codes: string[];
}
